import { Button } from "@mantine/core";
import { useControlSize } from "../../theme/useControlSize";

/**
 * Opens the barcode scanner.
 *
 * A thin wrapper on purpose. The scanner itself already exists and works -
 * BarcodeScanner in capture/, with a native BarcodeDetector path, a zxing-wasm
 * fallback, a probe that proves the decoder before claiming it, and a
 * "type it instead" escape. None of that is re-implemented here.
 *
 * Its CSP requirement ('wasm-unsafe-eval') and the fake-camera drive that
 * regression-tests it are equally untouched. This component only makes the
 * button look like the rest of the app.
 */
export function ScanButton({
  onClick,
  label = "Scan the barcode",
  variant = "default",
  fullWidth = true,
}: {
  onClick: () => void;
  label?: string;
  variant?: string;
  fullWidth?: boolean;
}) {
  const size = useControlSize();
  return (
    <Button size={size} variant={variant} fullWidth={fullWidth} onClick={onClick}>
      {label}
    </Button>
  );
}
